import { jsx as _jsx } from "react/jsx-runtime";
const URL_RE = /(https?:\/\/[^\s]+)/g;
/** Split text into plain segments and clickable http(s) links with ellipsis cap (raw prototype). */
export function linkify(text, linkMax) {
    const parts = String(text).split(URL_RE);
    return parts.map((t, i) => /^https?:\/\//.test(t) ? (_jsx("a", { href: t, target: "_blank", rel: "noopener noreferrer", onClick: (e) => e.stopPropagation(), style: {
            color: '#2563EB',
            textDecoration: 'underline',
            display: 'inline-block',
            maxWidth: linkMax,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            verticalAlign: 'bottom',
        }, children: t }, i)) : (t));
}
